import { Navigation } from "./Navigation/Navigation";
import { QuestionAnswer } from "../QuestionAnswer/QuestionAnswer";
export const Banner = (props) => {
    const { handleSaveUserData } = props;
  return (
    <div className="iplContestBanner">
      <div className="container">
        <Navigation />
        <div className="bannerContent">
          <div className="pridictionWrapper" style={{maxWidth:'500px'}}>
            <div className="pridictWin">
              <img src="https://d2hp1eprs.blob.core.windows.net/d2h-eprs-pay-banners/Predict-and-Win-KV-Final.png" alt="" />
            </div>
          </div>
          <div className="quizContainer">
            <QuestionAnswer handleSaveUserData={handleSaveUserData} />
          </div>
        </div>
      </div>
    </div>
  );
};
